export enum Lock {
    TOKEN_REFRESH = 'TOKEN_REFRESH',
    SEND_REQUEST = 'SEND_REQUEST',
    LISTEN_UNREAD_MESSAGES_COUNT = 'LISTEN_UNREAD_MESSAGES_COUNT',
}
